module.exports = __webpack_public_path__ + "static/media/245134.b984bf8f.jpg";